import React, { useEffect, useState } from 'react';
import { getState } from "../state";
import { shopSliderInit } from '../../sliders';
import showHide from '../../../functions/showhide';
import resetZoom from "../utlis/resetZoom";

const ShopPreview = () => {
  const [ iframeActive, setIframeActive ] = useState(false);
  const [ state, dispatch ] = getState();
  const { activeShopPreview } = state;
  const shop = activeShopPreview;

  useEffect(() => {
    shopSliderInit();
    setIframeActive(false);
    showHide('.map-sidebar [data-toggle="show-hide"]');
  }, [ activeShopPreview ]);

  if (!activeShopPreview) return null;

  return (
    <React.Fragment>
      <div className={`container w-100 back-link-wrapper ${activeShopPreview ? 'is-active' : ''}`}>
        <div className="columns is-centered">
          <div className="column is-12">
            <a
              className="back-link"
              onClick={() => {
                dispatch({ type: "setActiveShopPreview", activeShopPreview: null });
                dispatch({ type: "setActiveShop", activeShop: null });
                dispatch({ type: "setDefaultStore", defaultStore: null });
                dispatch({ type: "setSelectedShops", selectedShops: [...state.shops] });

                resetZoom();

                window.history.replaceState({}, document.title, window.location.href.replace(window.location.search, ''));
              }}
            >
              Vissza az üzletekhez
            </a>
          </div>
        </div>
      </div>
      <div className={`map-sidebar__iframe-wrapper ${iframeActive ? 'is-active' : ''}`}>
        <iframe
          onLoad={() => setIframeActive(true)}
          className={`map-sidebar__iframe`}
          src={shop.url}
          frameBorder='none'/>
      </div>
    </React.Fragment>
  )
};

export default ShopPreview;



// WEBPACK FOOTER //
// ./resources/assets/js/components/map/components/ShopPreview.jsx